import React, { FC } from 'react';
import t from 'utils/translationHelper';

import { Footer as OriginalFooter } from '@alpha/ui-lib/ui/layout/Footer';

const VERSION = process.env.REACT_APP_VERSION;

export const Footer: FC = () => {

  const footerLinks = [
    { text: t('privacy_and_cookie_policy'), url: 'https://alphagroup.com/private-markets/privacy-policy' },
    { text: t('terms_of_use'), url: 'https://www.alphagroup.com/legal/' },
    { text: VERSION ? `v.${VERSION}` : '', url: '' },
  ];
  return (
    <OriginalFooter
      testId="main-footer"
      footerLinks={footerLinks}
    />
  );
};
